import {
  AnyAction,
  CombinedState,
  configureStore,
  EnhancedStore,
} from '@reduxjs/toolkit'
import createSagaMiddleware, { SagaMiddleware } from 'redux-saga'
import { rootReducer } from './rootReducer'
import { rootSaga } from './rootSaga'

export const createStore = (): EnhancedStore<
  // eslint-disable-next-line @typescript-eslint/ban-types
  CombinedState<{ user: {} }>,
  AnyAction,
  // eslint-disable-next-line @typescript-eslint/ban-types
  SagaMiddleware<object>[]
> => {
  const sagaMiddleware = createSagaMiddleware()
  const store = configureStore({
    reducer: rootReducer,
    middleware: [sagaMiddleware],
    devTools: process.env.REACT_APP_PHASE === 'dev',
  })
  sagaMiddleware.run(rootSaga)
  return store
}
